// extracted by mini-css-extract-plugin
export var author = "style-module--author--3001e";
export var container = "style-module--container--97b53";
export var left = "style-module--left--ed81f";
export var right = "style-module--right--6d2a7";